import { Kernrecht } from '../kernrecht/kernrecht.model';
export class Kernnavigation {
  id: string;
  typ: string;
  vater: Kernnavigation;
  kinder: Kernnavigation[];
  recht: Kernrecht;
  ziel: string;
  sprachschluessel: string;
  uebersetzung: string;
  url: string;
  urlschema: string;
  host: string;
  pfad: string;
  query: string;
  fragment: string;
  reihenfolge: number;
  maxReihenfolge: number;
  icon: string;
  md2DataTableSort_Sprachschluessel: string;
  vaterOrig: Kernnavigation;
  md2DataTableSort_Reihenfolge: string;
  md2DataTableSort_Ebene: number;
  treePath: string;
}
